export enum ELocationStatuses {
  ACTIVE = 'Active',
  PROPOSED = 'Proposed',
}
